// Auth backend (Sign in with Hytale): /api/hytale-auth/login (редирект), /api/hytale-auth/me, /api/hytale-auth/logout.
// Сессия — HttpOnly-cookie, поэтому запросы идут с credentials: 'include'.
// Префикс /api/hytale-auth/ отделён от /api/auth/ wiki-backend, чтобы не конфликтовать.
export const AUTH_CONFIG = {
  apiUrl: process.env.REACT_APP_AUTH_API_URL ?? 'https://interworld.fun/api/hytale-auth',
};

// Profile backend (rating-backend): /api/profile/me — агрегированный профиль
// (статистика, донат-баланс, клан) по сессионной cookie auth-backend'а.
export const PROFILE_CONFIG = {
  apiUrl: process.env.REACT_APP_PROFILE_API_URL ?? 'https://interworld.fun/api/profile',
};

// Wiki backend API: JWT (POST /api/auth/login), публичные /api/wiki/*, админка /api/wiki-admin/* с Bearer.
// Прокси не используется — запросы идут напрямую на apiUrl. На бэкенде должен быть CORS (например *).
export const WIKI_CONFIG = {
  apiUrl: process.env.REACT_APP_WIKI_API_URL ?? 'https://interworld.fun',
  sessionTimeout: 3600000, // fallback для срока жизни сессии (в основном используется expiresIn из ответа логина)
};

// Backend рейтинга (rating-backend, таблица player_stats). По умолчанию проксируется через тот же домен.
export const RATING_CONFIG = {
  apiUrl: process.env.REACT_APP_RATING_API_URL ?? 'https://interworld.fun/api/rating',
  // Прокси аватаров игроков (gotale.net) через backend: /api/rating/avatar/{username}.
  avatarUrl: process.env.REACT_APP_RATING_AVATAR_URL ?? 'https://interworld.fun/api/rating/avatar',
};

export const DONATE_CONFIG = {
  apiUrl: "https://interworld.fun/api/payments/donation",
  apiKey: "d65f87f5-c837-4bac-96ef-9f513bc2a037",
  donateCurrencyCheckUrl: "https://interworld.fun/api/iwdonate/check",
  // Курс конвертации (должен совпадать с backend price.donate-currency-rate)
  // 100 ₽ = 1000 IW-Токенов => rate = 10 IW-Токенов за 1 ₽
  donateCurrencyRate: 10,
  categories: [
    {
      key: "donate_currency",
      title: "IW-Токены",
      description: "Пополните баланс IW-Токенов вашего игрового аккаунта. <b>Чем больше пакет — тем выгоднее курс!</b> Чтобы покупка прошла, ваш игрок должен хотя бы раз зайти на сервер.",
      items: [
        {
          key: "dc_pack_100",
          title: "1 000 IW-Токенов",
          description: "Пополнение IW-Токенов вашего аккаунта.",
          price: 100,
          priceUnit: "₽",
          type: "donate_currency_pack",
          currencyAmount: 1000,
          bonus: 0,
          fields: ["nickname"],
          features: ["100 ₽ = 1 000 IW-Токенов"]
        },
        {
          key: "dc_pack_250",
          title: "2 700 IW-Токенов",
          description: "Пополнение IW-Токенов вашего аккаунта.",
          price: 250,
          priceUnit: "₽",
          type: "donate_currency_pack",
          currencyAmount: 2700,
          bonus: 8,
          fields: ["nickname"],
          features: ["250 ₽ = 2 700 IW-Токенов", "+8% бонус"]
        },
        {
          key: "dc_pack_500",
          title: "5 700 IW-Токенов",
          description: "Пополнение IW-Токенов вашего аккаунта.",
          price: 500,
          priceUnit: "₽",
          type: "donate_currency_pack",
          currencyAmount: 5700,
          bonus: 14,
          fields: ["nickname"],
          features: ["500 ₽ = 5 700 IW-Токенов", "+14% бонус"]
        },
        {
          key: "dc_pack_1000",
          title: "12 000 IW-Токенов",
          description: "Пополнение IW-Токенов вашего аккаунта.",
          price: 1000,
          priceUnit: "₽",
          type: "donate_currency_pack",
          currencyAmount: 12000,
          bonus: 20,
          fields: ["nickname"],
          features: ["1 000 ₽ = 12 000 IW-Токенов", "+20% бонус"]
        },
        {
          key: "dc_pack_2500",
          title: "32 000 IW-Токенов",
          description: "Пополнение IW-Токенов вашего аккаунта.",
          price: 2500,
          priceUnit: "₽",
          type: "donate_currency_pack",
          currencyAmount: 32000,
          bonus: 28,
          fields: ["nickname"],
          features: ["2 500 ₽ = 32 000 IW-Токенов", "+28% бонус"]
        },
        {
          key: "dc_pack_5000",
          title: "68 000 IW-Токенов",
          description: "Пополнение IW-Токенов вашего аккаунта.",
          price: 5000,
          priceUnit: "₽",
          type: "donate_currency_pack",
          currencyAmount: 68000,
          bonus: 36,
          fields: ["nickname"],
          features: ["5 000 ₽ = 68 000 IW-Токенов", "+36% бонус"]
        }
      ]
    },
    {
      key: "support",
      title: "Поддержать",
      description: "Поддержка развития проекта.",
      items: [
        {
          key: "support_project",
          title: "Поддержать проект",
          description: "Если вам нравится наш проект вы можете его поддержать",
          type: "donation",
          customAmount: true,
          minAmount: 1,
          fields: ["nickname"],
          features: []
        }
      ]
    }
  ]
};
